import React,{Component} from 'react';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import { ClipLoader } from 'react-spinners';
import BlogCard from '../shared/BlogCard';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';

class BlogPage extends Component{
    state = {
        blogId:this.props.match.params.blogId,
        loading:true,
        blog:{},
        error:'',
        related:[]
    };
    componentDidMount = async () => {
        console.log(this.state.blogId);
        let blog = this.props.blogs.find(blog => blog.sys.id === this.state.blogId);
        let related  = this.props.blogs.filter(blog => blog.sys.id !== this.state.blogId);
        if(!blog) return this.setState({error:'No such blog present',loading:false});
        return this.setState({blog,loading:false,related});

    };
    componentDidUpdate(prevProps){
        if(this.props.match.params.blogId !== prevProps.match.params.blogId){
            let blog = this.props.blogs.find(blog => blog.sys.id === this.props.match.params.blogId);
            let related = this.props.blogs.filter(blog => blog.sys.id !== this.props.match.params.blogId);
            this.setState({blog,related});
            document.body.scrollTo(0,0);
            document.documentElement.scrollTo(0,0);
        }
    };
    render(){
        const {blog,loading,error,related} = this.state;
        const options = {
            renderNode:{
                "embedded-asset-block":(node) => {
                  const img = node.data.target.fields.file.url;
                  const alt = node.data.target.fields.title;
                  return <img src={img} alt={alt} className="blog_content_img"/>
                }
            }
        }
        return(
            <section className="blog">
                <Helmet>
                    {
                       !loading ? (<title>{blog['fields']['heading']}</title>) : null
                    }
                </Helmet>
                <div className="container">
                    <div className="row">
                        {
                            loading ? (
                                <div className="col-12 col-sm-12 mt-10 mb-10 text-center">
                                    <ClipLoader size="30" color="#009933"/>
                                </div>
                            ):(
                            error ? (
                                <div className="col-12 col-sm-12 mt-10 mb-10 text-center">
                                    <h3>{error}</h3>
                                </div>
                            ):(
                                <div className="col-12 col-sm-12 col-md-12">


                                <div className="blog_heading">
                                <h3>{blog['fields']['heading']}</h3>
                                <div className="blog_divider"/>
                                </div>

                                <div className="col-12 col-sm-12 col-md-12 blog_content">
                                {
                                    documentToReactComponents(blog.fields.body,options)
                                }
                                </div>
                                </div>
                            )
                            )
                        }
                        <div className="col-12 col-sm-12 col-md-12">
                            <div className="blog_heading">
                            <h3>Related articles</h3>
                            <div className="blog_divider"/>
                            </div>
                        </div>
                        {
                          related.map((blog,index) => (
                              <div className="col-sm-3 col-md-3" key={index}>
                                  <BlogCard data={blog}/>
                              </div>
                          ))
                        }           
                    </div>
                </div>
            </section>
        )
    }
};
const mapToProps = state => ({
    blogs:state.blogs.blogs
});
export default connect(mapToProps,null)(BlogPage);